var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.savingNotificationVisible
    ? _c(
        "div",
        { staticClass: "saving-notification saving-notification--vue" },
        [_vm._v("Sparar...")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/savingNotification.vue?vue&type=template&id=5c79f1cf&
// module id = 505
// module chunks = 0